// test654
(654 && 0);
